function normalize(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

function productOf(row) {
  return row.SHEET_NAME || row.PRODUCT_NAME || '';
}

function sameMoney(sheet, webhook) {
  if (sheet.MONTO == null || webhook.amount == null) return false;
  return Math.round(Number(sheet.MONTO) * 100) === Math.round(Number(webhook.amount) * 100);
}

function dateDistance(sheet, webhook) {
  if (!(sheet.FECHA instanceof Date) || !webhook.confirmationDate) return Infinity;
  return Math.abs(sheet.FECHA.getTime() - new Date(webhook.confirmationDate).getTime());
}

function isMatch(sheet, webhook) {
  if (!sameMoney(sheet, webhook)) return false;
  const sheetProduct = normalize(productOf(sheet));
  const webhookProduct = normalize(webhook.productName);
  if (sheetProduct && webhookProduct && sheetProduct !== webhookProduct) return false;

  const adMatches = sheet.AD_ID && webhook.adId && String(sheet.AD_ID) === String(webhook.adId);
  const postMatches =
    sheet.POST_ID && webhook.postId && String(sheet.POST_ID) === String(webhook.postId);
  const distance = dateDistance(sheet, webhook);
  if (adMatches || postMatches) return distance <= 24 * 60 * 60 * 1000;
  return distance <= 60 * 1000;
}

function metaFields(item, source) {
  return {
    SOURCE: source,
    RECONCILIATION_STATUS: source === 'reconciled' ? 'reconciled' : 'webhook_only',
    EVENT_ID: item.eventId,
    DELIVERY_ID: item.deliveryId,
    CTWA_CLID: item.ctwaClid || '',
    CTWA_PRESENT: item.ctwaClidPresent,
    META_STATUS: item.metaStatus,
    META_MODE: item.metaMode,
    META_ATTEMPTS: item.attempts,
    META_LAST_ATTEMPT: item.lastAttemptAt,
    META_SENT_AT: item.sentAt,
    META_ERROR_CODE: item.errorCode,
    META_ERROR_MESSAGE: item.errorMessage,
    SALE_STATUS: item.saleStatus,
  };
}

export function reconcileSales(sheetRows, webhookSales) {
  const rows = sheetRows.map((row) => ({
    ...row,
    SOURCE: 'google_sheets',
    RECONCILIATION_STATUS: 'unmatched_sheet',
  }));
  const sheetRowCount = rows.length;
  const used = new Set();
  let reconciled = 0;
  let ambiguous = 0;

  for (const webhook of webhookSales) {
    const candidates = rows
      .slice(0, sheetRowCount)
      .map((row, index) => ({ row, index }))
      .filter(({ row, index }) => !used.has(index) && isMatch(row, webhook));

    if (candidates.length === 1) {
      const match = candidates[0];
      rows[match.index] = { ...match.row, ...metaFields(webhook, 'reconciled') };
      used.add(match.index);
      reconciled += 1;
      continue;
    }
    if (candidates.length > 1) ambiguous += 1;

    rows.push({
      STATUS: webhook.saleStatus === 'needs_review' ? 'Requiere revisión' : 'Venta webhook',
      NOMBRE: webhook.customerName || '',
      FECHA: new Date(webhook.confirmationDate),
      FECHA_RAW: webhook.confirmationDate,
      NUMERO: webhook.customerPhone || '',
      MONTO: webhook.amount == null ? 0 : Number(webhook.amount),
      PAGO_RAW: webhook.amount || '',
      BANCO: webhook.bank || '',
      AD_ID: webhook.adId || '',
      EMAIL: webhook.customerEmail || '',
      POST_ID: webhook.postId || '',
      SHEET_NAME: webhook.productName || '',
      PRODUCT_NAME: webhook.productName || '',
      CURRENCY: webhook.currency || '',
      ...metaFields(webhook, 'clicchat_webhook'),
    });
  }

  return {
    rows,
    report: {
      reconciled,
      webhookOnly: webhookSales.length - reconciled,
      unmatchedSheets: rows.filter((row) => row.RECONCILIATION_STATUS === 'unmatched_sheet')
        .length,
      ambiguous,
    },
  };
}
